"use strict"
;(() => {
  /******************************************************************/
  /* GLOBALS
    /******************************************************************/

  let freeShippingIDs = cartValues.freeShippingVariants

  let shippingRate = cartValues.freeShipping.priceValue
  let shippingRate_switzerland = cartValues.freeShipping.priceValue__switzerland
  let shippingRate_international = cartValues.freeShipping.priceValue__international

  let minSubtotalPriceValue = cartValues.freeShipping.minSubtotalPriceValue
  let minOrderValue = cartValues.minOrderValue
  let currency

  let freeGiftXvariantId = cartValues.freeProductX.variantId
  let freeGiftYvariantId = cartValues.freeProductY.variantId

  let upsellProductsAddedJSON = sessionStorage.getItem("upsellProductsAdded")
  let upsellProductsAdded
  let isMobile

  // set upsellProductsadded Array for upsell add to cart or remove
  if (upsellProductsAddedJSON) {
    upsellProductsAdded = JSON.parse(upsellProductsAddedJSON)
  } else {
    upsellProductsAdded = []
    let initialUpsellProductsAddedJSON = JSON.stringify(upsellProductsAdded)
    sessionStorage.setItem("upsellProductsAdded", initialUpsellProductsAddedJSON)
  }

  // set currency
  if (window.Shopify.currency.active == "USD") {
    currency = "$"
  } else if (window.Shopify.currency.active == "EUR") {
    currency = "€"
  }

  /******************************************************************/
  /* County 
    /******************************************************************/
  let country = window.Shopify.country
  let isGermany = country == "DE"
  let isSwitzerland = country == "CH"
  let isInternational = isGermany == false && isSwitzerland == false
  // console.log("country: " + country)
  // console.log("isGermany: " + isGermany)
  // console.log("isSwitzerland: " + isSwitzerland)
  // console.log("isInternational: " + isInternational)

  shippingRate = isSwitzerland ? shippingRate_switzerland : shippingRate
  shippingRate = isInternational ? shippingRate_international : shippingRate

  /******************************************************************/
  /* fetch update cart
  /******************************************************************/

  let cartUpdates
  const resetCartUpdates = () => {
    cartUpdates = {
      updates: {},
    }
  }

  const pushCartUpdate = (variantId, quantity) => {
    cartUpdates.updates[variantId] = quantity
  }

  const pushCartUpdates = (variantIds, quantity) => {
    variantIds.forEach((variantId) => {
      pushCartUpdate(variantId, quantity)
    })
  }

  const applyCartUpdates = () => {
    updateCart(cartUpdates)
    resetCartUpdates()
    hideError()
  }

  const updateCart = async (cartUpdates) => {
    try {
      console.log("cartUpdates: " + cartUpdates)

      const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cartUpdates),
      })

      if (response.ok) {
        // console.log('cool');
        const event = new CustomEvent("cart:refresh", { bubbles: true })
        document.documentElement.dispatchEvent(event)
      } else {
        throw new Error("Network response was not ok")
      }

      return response.ok
    } catch (error) {
      console.error("Error:", error)
      return false
    }
  }

  /******************************************************************/
  /* cartBlocking
  /******************************************************************/

  const ID_errorContainer = "cartErrorContainer"
  const ID_checkoutButton = "cartCheckoutButton"

  const cartError__swizerland = {
    title: "Versand in die Schweiz",
    message: "Leider können wir den XXL Adventskalender nur als Einzelprodukt in die Schweiz verschicken.",
    button: "Warenkorb Aktualisieren",
  }
  const cartError__preOrder = {
    title: "XXL Kalender",
    message: "Um den Kalender mit anderen Produkten zusammen zu bestellen, musst du einen Warenwert von 24.99€ (ohne Kalender) erreichen.",
    button: "Nur Kalender kaufen",
  }
  const cartError__preOrder_swizzerland = {
    title: "XXL Kalender",
    message: "Der XXL Adventskalender kann leider nicht mit anderen Produkten zusammen in die Schweiz bestellt werden.",
    button: "Warenkorb Aktualisieren",
  }

  const showError = (error) => {
    //hide checkout button
    let checkoutButton = document.getElementById(ID_checkoutButton)
    checkoutButton.style.display = "none"
    console.log(checkoutButton)
    //show error
    let errorContainer = document.getElementById(ID_errorContainer)
    errorContainer.innerHTML = `
        <div class="cart-error">
            <p>${error.message}</p>
            <button id="errorButton">${error.button}</button>
        </div>
    `
    errorContainer.style.display = "block"
    //add event listener to error button
    let errorButton = document.getElementById("errorButton")
    errorButton.addEventListener("click", applyCartUpdates)

    console.log("show Error")

    //hide Payment Image
    let paymentImage = document.querySelector(".payment__image")
    paymentImage.style.display = "none"
  }

  const hideError = (error) => {
    //show checkout button
    let checkoutButton = document.getElementById(ID_checkoutButton)
    if (checkoutButton) checkoutButton.style.display = "block"
    //hide error
    let errorContainer = document.getElementById(ID_errorContainer)
    if (errorContainer) {
      errorContainer.innerHTML = ""
      errorContainer.style.display = "none"
    }

    //show Payment Image
    let paymentImage = document.querySelector(".payment__image")
    if (paymentImage) paymentImage.style.display = "block"
  }

  const canOrder__switzerland = () => {
    if (!isSwitzerland) return true

    let variantID_limited_Swizerland = 45003217273097
    let variantIDs_disalow_Swizerland = [45003217305865, 45003217338633, 45060118315273]

    let cartItems = document.querySelectorAll(".mini-cart__line-item")

    let numberLimitedVariant = 0
    let numberDisalowVariant = 0
    let numberOtherVariant = 0

    cartItems.forEach(function (cartItem) {
      // console.log("cartItem: " + cartItem.dataset.variantId)
      // console.log("cartItem: " + cartItem.dataset.quantity)
      let variantId = parseInt(cartItem.dataset.variantId)
      let quantity = parseInt(cartItem.dataset.quantity)

      if (variantId == variantID_limited_Swizerland) {
        numberLimitedVariant = quantity
      } else if (variantIDs_disalow_Swizerland.includes(variantId)) {
        numberDisalowVariant += quantity
      } else {
        numberOtherVariant += quantity
      }
    })

    console.log("numberLimitedVariant: " + numberLimitedVariant)
    console.log("numberDisalowVariant: " + numberDisalowVariant)
    console.log("numberOtherVariant: " + numberOtherVariant)

    if (numberOtherVariant >= 0 && numberDisalowVariant + numberLimitedVariant == 0) return true
    if (numberOtherVariant == 0 && numberDisalowVariant == 0 && numberLimitedVariant == 1) return true

    resetCartUpdates()

    cartItems.forEach(function (cartItem) {
      let variantId = parseInt(cartItem.dataset.variantId)

      if (variantId != variantID_limited_Swizerland) {
        pushCartUpdate(variantId, 0)
      }
    })

    if (numberLimitedVariant != 1) {
      pushCartUpdate(variantID_limited_Swizerland, 1)
    }

    showError(cartError__swizerland)
    return false
  }

  const canOrder__preOrder = () => {
    let preorderType = "pre-order"
    let exeptionType = "order-exeption"

    let cartItems = document.querySelectorAll(".mini-cart__line-item")

    let variantIDs_preorder = []
    let variantIDs_notPreorder = []
    let variantIDs_exeption = []
    let cartValue_exeption = 0
    let cartValue_notPreorder = 0

    cartItems.forEach(function (cartItem) {
      // console.log("cartItem: " + cartItem.dataset.variantId)
      // console.log("cartItem: " + cartItem.dataset.quantity)
      let variantId = parseInt(cartItem.dataset.variantId)
      let type = cartItem.dataset.productType
      let tags = cartItem.dataset.productTags
      let quantity = parseInt(cartItem.dataset.quantity)
      let price = parseInt(cartItem.dataset.productPrice)
      //console.log("type: " + type)

      if (type == preorderType || (tags && tags.includes(preorderType))) {
        //console.log("preorder")
        variantIDs_preorder.push(variantId)
      } else if (tags && tags.includes(exeptionType)) {
        variantIDs_exeption.push(variantId)
        cartValue_exeption += price * quantity
      } else {
        variantIDs_notPreorder.push(variantId)
        cartValue_notPreorder += price * quantity
      }
    })
    console.log("cartValue_preorder: " + cartValue_notPreorder)

    // console.log("variantIDs_preorder: " + variantIDs_preorder)
    // console.log("variantIDs_notPreorder: " + variantIDs_notPreorder)
    if (variantIDs_notPreorder.length == 0 || variantIDs_preorder.length == 0) return true
    if (cartValue_notPreorder + cartValue_exeption >= 2499) return true

    resetCartUpdates()

    pushCartUpdates(variantIDs_notPreorder, 0)

    showError(cartError__preOrder)
    return false
  }

  const canOrder__preOrder_swizzerland = () => {
    if (!isSwitzerland) return true

    let preorderType = "pre-order"

    let cartItems = document.querySelectorAll(".mini-cart__line-item")

    let variantIDs_preorder = []
    let variantIDs_notPreorder = []

    cartItems.forEach(function (cartItem) {
      // console.log("cartItem: " + cartItem.dataset.variantId)
      // console.log("cartItem: " + cartItem.dataset.quantity)
      let variantId = parseInt(cartItem.dataset.variantId)
      let type = cartItem.dataset.productType
      let tags = cartItem.dataset.productTags
      //console.log("type: " + type)

      if (type == preorderType || tags.includes(preorderType)) {
        console.log("preorder")
        variantIDs_preorder.push(variantId)
      } else {
        variantIDs_notPreorder.push(variantId)
      }
    })

    // console.log("variantIDs_preorder: " + variantIDs_preorder)
    // console.log("variantIDs_notPreorder: " + variantIDs_notPreorder)

    if (variantIDs_notPreorder.length == 0 || variantIDs_preorder.length == 0) return true

    resetCartUpdates()

    pushCartUpdates(variantIDs_notPreorder, 0)

    showError(cartError__preOrder_swizzerland)
    return false
  }

  const checkForIllegalCart = () => {
    // if (!canOrder__switzerland()) return
    if (!canOrder__preOrder()) return
    if (!canOrder__preOrder_swizzerland()) return
    hideError()
  }

  /******************************************************************/
  /* mobile check
  /******************************************************************/

  const checkIfIsMobile = () => {
    if (window.matchMedia("(max-width: 767px)").matches) {
      isMobile = true
    } else {
      isMobile = false
    }
  }

  checkIfIsMobile()
  window.addEventListener("resize", checkIfIsMobile)

  /******************************************************************/
  /* main Function
  /******************************************************************/

  document.addEventListener("DOMContentLoaded", () => {
    checkAndAddRemoveFreeGift()
    initUpsellProductsSlider()
    showUpsellProduct()
    incentiveBar()
    totalCalculation()
    //checkForIllegalCart()

    let incentiveBarWithFreeGifts = JSON.parse(document.querySelector(".Cart__values").dataset.incentiveBarWithFreeGifts)

    if (incentiveBarWithFreeGifts) {
      // remove disabled on reload
      const submitButton = document.querySelector('.cart-drawer .button[type="submit"]')
      submitButton && (submitButton.disabled = false)
      document.querySelector(".cart-drawer").classList.remove("disable-button")

      document.addEventListener("theme:loading:start", () => {
        const submitButton = document.querySelector('.cart-drawer .button[type="submit"]')
        submitButton && (submitButton.disabled = true)
        document.querySelector(".cart-drawer").classList.add("disable-button")
      })
    }

    document.addEventListener("theme:loading:end", () => {
      document.querySelector(".cart-drawer").classList.add("loading")

      if (incentiveBarWithFreeGifts) {
        document.querySelector(".cart-drawer").classList.add("disable-button")
      }

      setTimeout(() => {
        document.querySelector(".cart-drawer").classList.remove("loading")

        checkAndAddRemoveFreeGift()
        initUpsellProductsSlider()
        showUpsellProduct()
        incentiveBar()
        totalCalculation()
        checkForIllegalCart()
      }, 500)

      if (incentiveBarWithFreeGifts) {
        setTimeout(() => {
          document.querySelector(".cart-drawer").classList.remove("disable-button")

          const interval = setInterval(() => {
            const submitButton = document.querySelector('.cart-drawer .button[type="submit"]')

            if (submitButton != undefined) {
              submitButton && (submitButton.disabled = false)
              // console.log("remove disable")

              clearInterval(interval)
            }
          }, 250)
        }, 1500)
      }
    })
  })

  /******************************************************************/
  /* Free Gift
  /******************************************************************/

  const checkAndAddRemoveFreeGift = async () => {
    const freeGiftX = document.querySelector(".mini-cart__line-item.free-gift-x")
    const freeGiftY = document.querySelector(".mini-cart__line-item.free-gift-y")
    let freeGiftXQuantity = freeGiftX ? parseInt(freeGiftX?.dataset.quantity) : 0
    let freeGiftYQuantity = freeGiftY ? parseInt(freeGiftY?.dataset.quantity) : 0
    let cartTotalPriceFloat = parseFloat(document.querySelector(".Cart__values").dataset.cartTotalPriceFloat)
    let incentiveBarWithFreeGifts = JSON.parse(document.querySelector(".Cart__values").dataset.incentiveBarWithFreeGifts)

    // console.log("freegiftx: " + freeGiftXQuantity)
    // console.log("freegifty: " + freeGiftYQuantity)

    if (incentiveBarWithFreeGifts) {
      if (cartTotalPriceFloat < 75) {
        //console.log('remove x')
        if (freeGiftX || freeGiftY) {
          // console.log("REMOVE X: " + freeGiftX)
          // console.log("REMOVE Y: " + freeGiftY)
          await fetchUpdateProduct(freeGiftXvariantId, 0)
          await fetchUpdateProduct(freeGiftYvariantId, 0)
        }
      } else if (cartTotalPriceFloat < 100) {
        //console.log('remove y')
        if (freeGiftY) {
          // console.log("REMOVE Y: " + freeGiftY)
          await fetchUpdateProduct(freeGiftYvariantId, 0)
        }

        if (!freeGiftX) {
          // console.log("ADD X: " + freeGiftY)
          await fetchAddProduct(freeGiftXvariantId)
        }

        // edge case if product is greater 1
        if (freeGiftXQuantity > 1) {
          await fetchUpdateProduct(freeGiftXvariantId, 1)
        }
      } else {
        if (!freeGiftY) {
          // console.log("ADD Y: " + freeGiftY)
          await fetchAddProduct(freeGiftYvariantId)
        }

        if (!freeGiftX) {
          // console.log("ADD X: " + freeGiftX)
          await fetchAddProduct(freeGiftXvariantId)
        }

        // edge case if product is greater 1
        if (freeGiftXQuantity > 1) {
          // update product
          await fetchUpdateProduct(freeGiftXvariantId, 1)
        }

        if (freeGiftYQuantity > 1) {
          // update product
          await fetchUpdateProduct(freeGiftYvariantId, 1)
        }
      }
    }
  }

  /******************************************************************/
  /* incentive bar
  /******************************************************************/

  const incentiveBar = () => {
    let cartValues = {
      cartTotalPrice: document.querySelector(".Cart__values").dataset.cartTotalPrice,
      cartTotalPriceFloat: document.querySelector(".Cart__values").dataset.cartTotalPriceFloat,
      incentiveBarWithFreeGifts: document.querySelector(".Cart__values").dataset.incentiveBarWithFreeGifts,
    }
    hideIncentiveBar(!isGermany)
    fillProgressBar(cartValues)
    fillProgressBarIcons(cartValues)
    incentiveInformation(cartValues)

    // if percentage > 100 show free shipping
    // if(cheeringBarPercentage >= 100) {
    //     document.querySelector('.Cart__cheering-bar-content span').innerHTML = cartValues.freeShippingSaveText + " <b>" + cartValues.freeShippingExclamationMarkText + "</b>";
    // } else {
    //     document.querySelector('.Cart__cheering-bar-content span').innerHTML = "Nur noch " + "<b>" + remainingPriceFormatted + currency + "</b> " + cartValues.freeShippingFromText + " " + cartValues.freeShippingText;
    // }

    // show / hide cheering bar
    // if(cheeringBarPercentage <= 0) {
    //     document.querySelector('.Cart__cheering-bar').classList.remove('visible');
    //     document.querySelector('.upsell-products-wrapper').classList.remove('visible');
    // } else {
    //     document.querySelector('.Cart__cheering-bar').classList.add('visible');
    //     document.querySelector('.upsell-products-wrapper').classList.add('visible');
    // }
  }

  const hideIncentiveBar = (hide) => {
    //console.log("hide: " + hide)
    if (hide) {
      //console.log("hide")
      document.querySelector(".cart-drawer__incentive-bar").style.display = "none"
      document.querySelector(".cart-drawer").classList.add("no-incentive-bar")
    }
  }

  const fillProgressBar = (cartValues) => {
    let cartTotalPrice = parseFloat(cartValues.cartTotalPriceFloat)
    let incentiveBarWithFreeGifts = JSON.parse(cartValues.incentiveBarWithFreeGifts)

    if (incentiveBarWithFreeGifts) {
      if (cartTotalPrice <= 50) {
        let cheeringBarPercentageFreeShipping = (cartTotalPrice / 50) * 100

        document.querySelector(".progress--freeshipping .cart-drawer__incentive-bar-progress-background").style.width = cheeringBarPercentageFreeShipping + "%"
        document.querySelector(".progress--free-product-x .cart-drawer__incentive-bar-progress-background").style.width = "0%"
        document.querySelector(".progress--free-product-y .cart-drawer__incentive-bar-progress-background").style.width = "0%"
      } else if (cartTotalPrice <= 99.99) {
        let cheeringBarPercentageFreeProductX = ((cartTotalPrice - 50) / 50) * 100

        document.querySelector(".progress--freeshipping .cart-drawer__incentive-bar-progress-background").style.width = "100%"
        document.querySelector(".progress--free-product-y .cart-drawer__incentive-bar-progress-background").style.width = "0%"

        setTimeout(() => {
          document.querySelector(".progress--free-product-x .cart-drawer__incentive-bar-progress-background").style.width = cheeringBarPercentageFreeProductX + "%"
        }, 200)
      } else if (cartTotalPrice >= 100) {
        document.querySelector(".progress--freeshipping .cart-drawer__incentive-bar-progress-background").style.width = "100%"
        document.querySelector(".progress--free-product-x .cart-drawer__incentive-bar-progress-background").style.width = "100%"

        setTimeout(() => {
          document.querySelector(".progress--free-product-y .cart-drawer__incentive-bar-progress-background").style.width = "100%"
        }, 200)
      }
    } else {
      if (cartTotalPrice <= 69.99 && !hasFreeShipingVariants()) {
        let cheeringBarPercentageFreeShipping = (cartTotalPrice / 50) * 100
        document.querySelector(".progress--freeshipping-rest .cart-drawer__incentive-bar-progress-background").style.width = "0%"

        setTimeout(() => {
          document.querySelector(".progress--freeshipping .cart-drawer__incentive-bar-progress-background").style.width = cheeringBarPercentageFreeShipping + "%"
        }, 200)
      } else {
        document.querySelector(".progress--freeshipping .cart-drawer__incentive-bar-progress-background").style.width = "100%"

        setTimeout(() => {
          document.querySelector(".progress--freeshipping-rest .cart-drawer__incentive-bar-progress-background").style.width = "100%"
        }, 200)
      }
    }
  }

  const fillProgressBarIcons = (cartValues) => {
    let cartTotalPriceFloat = cartValues.cartTotalPriceFloat

    const freeShippingIcon = document.querySelector(".cart-drawer__incentive-bar .free-shipping-icon")
    const freeProductXIcon = document.querySelector(".cart-drawer__incentive-bar .free-product-x-icon")
    const freeProductYIcon = document.querySelector(".cart-drawer__incentive-bar .free-product-y-icon")

    freeShippingIcon.classList.toggle("active", cartTotalPriceFloat >= 70)
    freeProductXIcon?.classList.toggle("active", cartTotalPriceFloat >= 75)
    freeProductYIcon?.classList.toggle("active", cartTotalPriceFloat >= 100)
  }

  const incentiveInformation = (cartValues) => {
    let cartTotalPriceFloat = cartValues.cartTotalPriceFloat
    let remainingPrice
    let incentiveText
    let incentiveBarWithFreeGifts = JSON.parse(cartValues.incentiveBarWithFreeGifts)

    const formatPrice = (price) => {
      return price.toFixed(2).toString().replace(".", ",") + currency
    }

    if (incentiveBarWithFreeGifts) {
      if (cartTotalPriceFloat < 70) {
        remainingPrice = 70 - parseFloat(cartTotalPriceFloat)
        incentiveText = "Noch " + formatPrice(remainingPrice) + " bis zum gratis Versand"
      } else if (cartTotalPriceFloat < 75) {
        remainingPrice = 75 - parseFloat(cartTotalPriceFloat)
        incentiveText = "Noch " + formatPrice(remainingPrice) + " bis zu deinem 1. Geschenk"
      } else if (cartTotalPriceFloat < 100) {
        remainingPrice = 100 - parseFloat(cartTotalPriceFloat)
        incentiveText = "Noch " + formatPrice(remainingPrice) + " bis zu deinem 2. Geschenk"
      } else {
        incentiveText = "Du erhältst alle Prämien!"
      }
    } else {
      if (cartTotalPriceFloat < 70 && !hasFreeShipingVariants()) {
        remainingPrice = 70 - parseFloat(cartTotalPriceFloat)
        incentiveText = "Noch " + formatPrice(remainingPrice) + " bis zum kostenlosen Versand"
      } else {
        incentiveText = "Du erhältst kostenlosen Versand!"
      }
    }

    document.querySelector(".cart-drawer__incentive-bar .cart-drawer__incentive-bar-content span").innerHTML = incentiveText
  }

  /******************************************************************/
  /* fetch add product + fetch update Product
    /******************************************************************/

  const fetchAddProduct = async (variantId) => {
    try {
      const productObject = {
        id: variantId,
        quantity: 1,
      }

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(productObject),
      })

      if (response.ok) {
        const event = new CustomEvent("cart:refresh", { bubbles: true })
        document.documentElement.dispatchEvent(event)
      } else {
        throw new Error("Network response was not ok")
      }

      return response.ok
    } catch (error) {
      console.error("Error:", error)
      return false
    }
  }

  const fetchUpdateProduct = async (variantId, quantity) => {
    try {
      const cartUpdates = {
        updates: {
          [variantId]: quantity,
        },
      }

      const response = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cartUpdates),
      })

      if (response.ok) {
        const event = new CustomEvent("cart:refresh", { bubbles: true })
        document.documentElement.dispatchEvent(event)
      } else {
        throw new Error("Network response was not ok")
      }

      return response.ok
    } catch (error) {
      console.error("Error:", error)
      return false
    }
  }

  /******************************************************************/
  /* Totals Calculation
    /******************************************************************/

  const hasFreeShipingVariants = () => {
    let hasFreeShipingVariants = false
    let cartItems = document.querySelectorAll(".mini-cart__line-item")

    cartItems.forEach(function (cartItem) {
      let productTags = cartItem.dataset.productTags;

      if (productTags && productTags.includes("free-shipping")) {
        hasFreeShipingVariants = true
      }
    })
    return hasFreeShipingVariants
  }

  const totalCalculation = () => {
    // total calculation without dcart
    let cartTotalPriceFloat = document.querySelector(".Cart__values").dataset.cartTotalPriceFloat
    let cartItemCount = document.querySelector(".Cart__values").dataset.cartItemCount
    let shippingPrice = shippingRate

    if (parseFloat(cartTotalPriceFloat) > 0) {
      let freeShiping = (cartTotalPriceFloat >= minSubtotalPriceValue || hasFreeShipingVariants()) && isGermany

      if (freeShiping) {
        console.log("free shipping")
        shippingPrice = 0
      }

      let subTotalPrice = parseFloat(document.querySelector(".Cart__values").dataset.cartTotalPriceFloat)
      let totalPrice = subTotalPrice + parseFloat(shippingPrice)
      let shippingRateFormatted = shippingRate.toString().replace(".", ",") + currency
      let formattedSubTotalPrice = subTotalPrice.toFixed(2).toString().replace(".", ",") + currency
      let formattedTotalPrice = totalPrice.toFixed(2).toString().replace(".", ",") + currency

      //shipping price
      if (freeShiping) {
        document.querySelector(".cart-drawer .mini-cart__shipping-price").classList.add("free-shipping")
        document.querySelector(".cart-drawer .mini-cart__shipping-price").textContent = "Kostenlos"
      } else {
        document.querySelector(".cart-drawer .mini-cart__shipping-price").classList.remove("free-shipping")
        document.querySelector(".cart-drawer .mini-cart__shipping-price").textContent = shippingRateFormatted
      }

      // min value reached

      if (subTotalPrice < minOrderValue) {
        document.querySelector(".cart-drawer .button-group").classList.add("not-reached")
        document.querySelector(".cart-drawer .button-group .button--primary").classList.add("not-reached")
        document.querySelector(".cart-drawer .button__min-value-not-reached").classList.add("visible")
        document.querySelector(".cart-drawer .button__to-checkout").classList.remove("visible")
      } else {
        document.querySelector(".cart-drawer .button-group").classList.remove("not-reached")
        document.querySelector(".cart-drawer .button-group .button--primary").classList.remove("not-reached")
        document.querySelector(".cart-drawer .button__min-value-not-reached").classList.remove("visible")
        document.querySelector(".cart-drawer .button__to-checkout").classList.add("visible")
      }

      document.querySelector(".cart-drawer .mini-cart__subtotal-price").textContent = formattedSubTotalPrice
      document.querySelector(".cart-drawer .mini-cart__recap-price-line-total-price").textContent = formattedTotalPrice
    }

    document.querySelector(".header__cart-toggle .header__cart-count").innerHTML = cartItemCount
  }

  /******************************************************************/
  /* open close drawer
    /******************************************************************/

  // close drawer on icon
  document.querySelector(".cart-drawer .close-drawer").addEventListener("click", () => {
    document.querySelector(".cart-drawer .mini-cart").setAttribute("aria-hidden", "true")
    document.querySelector(".header__cart-toggle").setAttribute("aria-expanded", "false")
    document.querySelector("html").classList.remove("cart-drawer--open")
  })

  // close drawer outside click
  document.addEventListener("click", function (e) {
    let target = e.target

    if (target.matches(".cart-drawer")) {
      document.querySelector(".cart-drawer .mini-cart").setAttribute("aria-hidden", "true")
      document.querySelector(".header__cart-toggle").setAttribute("aria-expanded", "false")
      document.querySelector("html").classList.remove("cart-drawer--open")
    }
  })

  // handle overflow-y hidden
  const elements = document.querySelectorAll(".header__cart-toggle, .product-form__add-button")
  //const elements = document.querySelectorAll('.header__cart-toggle');

  //wait till buttons are loaded
  setTimeout(() => {
    const actionButtons = document.querySelectorAll(".product-item__action-button")

    actionButtons.forEach((element) => {
      element.addEventListener("click", () => {
        if (!isMobile && false) {
          // disable for now cartOpenOnAddToCart
          document.querySelector("html").classList.add("cart-drawer--open")
          document.querySelector(".header__cart-toggle")?.click()
        }
      })
    })
  }, 1000)

  elements.forEach((element) => {
    element.addEventListener("click", () => {
      if (!isMobile) {
        document.querySelector("html").classList.add("cart-drawer--open")
        document.querySelector(".header__cart-toggle")?.click()
      }

      if (element.classList.contains("header__cart-toggle")) {
        document.querySelector("html").classList.add("cart-drawer--open")
      }
    })
  })

  // remove class if cart drawer was open + custom popup
  document.querySelector("#custom-popup .button")?.addEventListener("click", () => {
    document.querySelector("html").classList.remove("cart-drawer--open")
  })

  /******************************************************************/
  /* UPSELL
  /******************************************************************/

  const showUpsellProduct = () => {
    const removeItems = document.querySelectorAll(".cart-drawer .mini-cart .mini-cart__line-item .mini-cart__quantity-remove")
    const decreaseQuantities = document.querySelectorAll('.cart-drawer .quantity-selector__button[data-action="decrease-quantity"]')
    const removeUpsellProducts = document.querySelectorAll(".cart-drawer .upsell-product__remove")
    let upsellProductsAddedJSON = sessionStorage.getItem("upsellProductsAdded")
    let upsellProductsAddedParsed = JSON.parse(upsellProductsAddedJSON)

    // click on remove button
    removeItems.forEach(function (removeItem) {
      removeItem.addEventListener("click", () => {
        let variantId = removeItem.closest(".mini-cart__line-item").dataset.variantId
        let indexToRemove = upsellProductsAddedParsed.indexOf(variantId)

        if (indexToRemove !== -1) {
          upsellProductsAddedParsed.splice(indexToRemove, 1)

          let updatedUpsellProductsAddedJSON = JSON.stringify(upsellProductsAddedParsed)
          sessionStorage.setItem("upsellProductsAdded", updatedUpsellProductsAddedJSON)
        }
      })
    })

    // click on decrease button, if value === 1
    decreaseQuantities.forEach(function (decreaseQuantity) {
      decreaseQuantity.addEventListener("click", (event) => {
        const quantity = parseInt(event.currentTarget.nextElementSibling.value)

        if (quantity === 1) {
          let variantId = decreaseQuantity.closest(".mini-cart__line-item").dataset.variantId
          let indexToRemove = upsellProductsAddedParsed.indexOf(variantId)

          if (indexToRemove !== -1) {
            upsellProductsAddedParsed.splice(indexToRemove, 1)

            let updatedUpsellProductsAddedJSON = JSON.stringify(upsellProductsAddedParsed)
            sessionStorage.setItem("upsellProductsAdded", updatedUpsellProductsAddedJSON)
          }
        }
      })
    })

    removeUpsellProducts.forEach(function (removeProduct) {
      removeProduct.addEventListener("click", (event) => {
        const variantId = event.target.closest(".upsell-product").dataset.variantId
        event.target.closest(".upsell-product").classList.add("is-hidden")
        const lengthOfAddedUpsellProducts = document.querySelectorAll(".cart-drawer .upsell-products .upsell-product:not(.is-hidden)").length

        // destroy and reinit swiper upsell slider
        document.querySelector(".cart-drawer .upsell-products").swiper.destroy()
        upsellSlider()

        // show / hide wrapper
        if (lengthOfAddedUpsellProducts === 0) {
          document.querySelector(".cart-drawer .upsell-products-wrapper")?.classList.add("hide")
        } else {
          document.querySelector(".cart-drawer .upsell-products-wrapper")?.classList.remove("hide")
        }

        if (!upsellProductsAddedParsed.includes(variantId)) {
          upsellProductsAddedParsed.push(variantId)

          let updatedUpsellProductsAddedJSON = JSON.stringify(upsellProductsAddedParsed)
          sessionStorage.setItem("upsellProductsAdded", updatedUpsellProductsAddedJSON)
        }
      })
    })
  }

  const initUpsellProductsSlider = () => {
    const upsellProducts = document.querySelectorAll(".cart-drawer .upsell-products .upsell-product")
    let upsellProductsAddedJSON = sessionStorage.getItem("upsellProductsAdded")
    let upsellProductsAddedParsed = JSON.parse(upsellProductsAddedJSON)

    upsellProducts.forEach(function (upsellProduct) {
      upsellProductsAddedParsed.forEach(function (upsellProductAddedId) {
        if (parseInt(upsellProductAddedId) === parseInt(upsellProduct.dataset.variantId)) {
          upsellProduct.classList.add("is-hidden")
        }
      })
    })

    // hide upsell products wrapper if all elements was added to cart
    const lengthOfAddedUpsellProducts = document.querySelectorAll(".cart-drawer .upsell-products .upsell-product:not(.is-hidden)").length

    if (lengthOfAddedUpsellProducts === 0) {
      document.querySelector(".cart-drawer .upsell-products-wrapper")?.classList.add("hide")
    } else {
      document.querySelector(".cart-drawer .upsell-products-wrapper")?.classList.remove("hide")
    }

    upsellSlider()

    const addToCartButtons = document.querySelectorAll(".cart-drawer .upsell-products .upsell-product__add-to-cart-button")
    let incentiveBarWithFreeGifts = JSON.parse(document.querySelector(".Cart__values").dataset.incentiveBarWithFreeGifts)

    addToCartButtons.forEach(function (addToCartButton) {
      addToCartButton.addEventListener("click", async (event) => {
        const variantId = event.target.dataset.variantId
        const submitButton = document.querySelector('.cart-drawer .button[type="submit"]')

        document.querySelector(".cart-drawer").classList.add("loading")

        if (incentiveBarWithFreeGifts) {
          document.querySelector(".cart-drawer").classList.add("disable-button")
          submitButton && (submitButton.disabled = true)
        }

        let productIsAdded = await fetchAddProduct(variantId)

        if (productIsAdded) {
          document.querySelector(".mini-cart__line-item-list").scrollTo({ top: 0, behavior: "smooth" })

          if (!upsellProductsAddedParsed.includes(variantId)) {
            upsellProductsAddedParsed.push(variantId)

            let updatedUpsellProductsAddedJSON = JSON.stringify(upsellProductsAddedParsed)
            sessionStorage.setItem("upsellProductsAdded", updatedUpsellProductsAddedJSON)
          }
        }
      })
    })
  }

  const upsellSlider = () => {
    new Swiper(".cart-drawer .upsell-products", {
      loop: false,
      // watchSlidesProgress: true,
      simulateTouch: true,
      allowTouchMove: true,
      slidesPerView: 1.1,
      spaceBetween: 10,
      slidesOffsetAfter: 10,
      mousewheel: {
        invert: false,
      },
      // breakpoints: {
      //     768: {
      //         direction: 'vertical',
      //         slidesPerView: 3,
      //         spaceBetween: 10,
      //         autoHeight: true,
      //         mousewheel: {
      //             invert: false,
      //           },
      //         navigation: {
      //             nextEl: ".swiper-button-next",
      //             prevEl: ".swiper-button-prev",
      //         },
      //     }
      // },
    })
  }
})()
